export default __webpack_public_path__ + "static/media/InputButtonIcon.933f5961.svg";